import React from 'react';
import styles from './ProgressSparklines.module.css';

const liftConfigs = [
  { label: 'Squat', keys: ['squat_day1', 'squat_day30', 'squat_day60', 'squat_day90'] },
  { label: 'Bench', keys: ['bench_day1', 'bench_day30', 'bench_day60', 'bench_day90'] },
  { label: 'Press', keys: ['press_day1', 'press_day30', 'press_day60', 'press_day90'] },
  { label: 'Deadlift', keys: ['deadlift_day1', 'deadlift_day30', 'deadlift_day60', 'deadlift_day90'] },
];

const Sparkline = ({ values }) => {
  const points = values.filter(v => v != null);
  if (points.length < 2) return null;

  const min = Math.min(...points);
  const max = Math.max(...points);
  const range = max - min || 1;
  const width = 160;
  const height = 28;
  const padding = 2;

  const coords = points.map((v, i) => {
    const x = padding + (i / (points.length - 1)) * (width - padding * 2);
    const y = height - padding - ((v - min) / range) * (height - padding * 2);
    return `${x},${y}`;
  });

  return (
    <svg width={width} height={height} style={{ flexShrink: 0 }}>
      <polyline
        points={coords.join(' ')}
        fill="none"
        stroke="#8DC153"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ProgressSparklines = ({ logbook }) => (
  <div className={styles.ProgressSparklines}>
    <h3 className={styles.Title}>Progress</h3>
    {liftConfigs.map(lift => {
      const values = lift.keys.map(k => logbook[k]);
      const points = values.filter(v => v != null);
      const min = points.length > 0 ? Math.min(...points) : 0;
      const max = points.length > 0 ? Math.max(...points) : 0;
      const pctGain = min > 0 ? Math.round(((max - min) / min) * 100) : 0;

      return (
        <div key={lift.label} className={styles.Row}>
          <span className={styles.LiftName}>{lift.label}</span>
          {points.length >= 2 ? (
            <>
              <Sparkline values={values} />
              <span className={styles.PctGain}>+{pctGain}%</span>
            </>
          ) : (
            <span className={styles.NoData}>Not enough data</span>
          )}
        </div>
      );
    })}
  </div>
);

export default ProgressSparklines;
